<template>
  <div class="actions">
    <div v-if="!loading">
      <h4>Data from HTTP request</h4>
      <div v-if="actions_old.length < 1" style="padding-bottom: 10px; border-bottom: 1px solid #000000">
        <h1 v-if="!actions_status" class="actions__title">
          Simcard deamon not response
        </h1>

        <h1 v-else class="actions__title">
          {{translate('no_data')}}
        </h1>
      </div>

      <div v-else >
        <div v-if="error" style="height: 100%">
          <h1 style="text-align: center" >
            {{translate('no_data')}}
          </h1>
        </div>
        <div class="buttons_list" style="padding-bottom: 10px; border-bottom: 1px solid #000000">
          <ActionButton
            v-for="(action, index) in actions_old"
            :key="index"
            class="item"
            :action_data="action"
            :profile="profile"
            @reload="get_actions"
          />
        </div>
      </div>
      <h4>Data from ServiceBridge</h4>
      <div v-if="Object.keys(list_new_actions).length < 1" style="padding-bottom: 10px; border-bottom: 1px solid #000000">
        <h1 class="actions__title">
          {{translate('no_data')}}
        </h1>
      </div>
      <div v-else >
        <div class="buttons_list" style="padding-bottom: 10px; border-bottom: 1px solid #000000">
          <template v-for="(service, service_index) in actions_ServiceBridge">
            <ActionButton
                v-for="(action, index) in service"
                :key="service_index + index"
                class="item"
                :action_data="action"
                :profile="profile"
                :service_name='service_index'
                @reload="get_actions"
            />
          </template>
        </div>
      </div>
      <template v-if="Object.keys(all_data).length">
        <h4>Task history</h4>
        <TextTable
            :all_data = "all_data"
        />
      </template>
    </div>
    <div v-else style="border:none; background-color:  transparent;">
      <scale-loader />
    </div>
  </div>
</template>

<script>
import ActionButton from './ActionButton.vue'
import TextTable from 'components/UIComponents/Plugins/TextTablePlagin/TextTable.vue';

export default {
  name: 'Actions',
  components: {
    ActionButton,
    TextTable
  },

  props: ['sim_id', 'profile'],

  data () {
    return {
      actions_old: [],
      list_new_actions: [],
      actions_ServiceBridge: {},
      actions_status: true,
      error: false,
      loading: true,
      reload: false,
      status_list: {},
      all_data: {}
    }
  },

  destroyed() {
    this.$store.dispatch("WS_Unsubscribe",`simcard_profile_action_list.${this.sim_id}`)
  },

  created () {
    this.get_actions()

    if(this.$store.getters.WsGetStatus) {
      this.subscribe()
    }
  },

  watch:{
    reload(){
      if (this.reload) {
        if(this.$store.getters.WsGetStatus) {
          this.interval = setInterval(() => {
            this.get_actions()
          }, this.$store.getters.getSimcardProfileActionsUpdate)
        }
      }else{
        clearInterval(this.interval)
      }
    }
  },

  methods: {
    show_status(status_id){
      return this.status_list[status_id]
    },
    subscribe(){
      this.$store.dispatch("WS_Subscribe",{ topic: `simcard_profile_action_list.${this.sim_id}`, func: this.ActionsFromServiceBridge, timeout: 0 })
    },
    get_actions(){
      if (this.$route.name === 'simcard_devices_section') {
        this.$http.simcard.getSimcardActions(this.sim_id, (response) => {
          if (!response.data.actions) {
            this.global_notify('danger', this.translate('simcard.no_action'))
          }
          this.actions_old = response.data.actions
          this.reload = this.actions_old.length < 1 && this.actions_status;

          this.all_data = response.data.simcard_actions

          this.loading = false
        })
      }
    },
    ActionsFromServiceBridge(cmd){
      if(cmd.data?.result.actions.length > 0) {
        this.actions_ServiceBridge[cmd.data?.service_name] = cmd.data?.result.actions
        let temp_arr = []
        for (let service_name in this.actions_ServiceBridge) {
          temp_arr = temp_arr.concat(this.actions_ServiceBridge[service_name])
        }
        this.list_new_actions = temp_arr
      }
      // this.actions_ServiceBridge = cmd.data?.result.actions
    },
  },


}
</script>
<style lang="scss" scoped>
  .actions{
    &__title{
      text-align: center;
      margin: 10px;
    }
    .response_table{
      height: auto;
    }
    .buttons_list{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .item{
        margin: 5px;
      }
    }
  }

 </style>
